export default "__VITE_ASSET__Fmsa4MQU__"